export { LoaderComponent } from './loader.component';
export { L_LoaderModule } from './loader.module';



// WEBPACK FOOTER //
// ./.tmp/loader/index.ts